var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapedesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 329,
    viewBox: "0 0 363 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0625,
    y: 0.437439,
    width: 360.625,
    height: 326.875,
    stroke: "#005CFF",
    strokeWidth: 0.625
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.353 327.837L0.728027 0.92218M361.353 327.837L0.728027 24.315M361.353 327.837L0.728027 47.7079M361.353 327.837L0.728027 71.1008M361.353 327.837L0.728027 94.4936M361.353 327.837L0.728027 117.886M361.353 327.837L0.728027 141.279M361.353 327.837L0.728027 164.672M361.353 327.837L0.728027 188.065M361.353 327.837L0.728027 211.458M361.353 327.837L0.728027 234.851M361.353 327.837L0.728027 258.244M361.353 327.837L0.728027 281.636M361.353 327.837L0.728027 305.029M361.353 327.837L0.728027 327.312",
    stroke: "#005CFF",
    strokeWidth: 0.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapedesktop);
export default __webpack_public_path__ + "static/media/shape.desktop.6d7c6c294f73d44d4481721cd5d519f8.svg";
export { ForwardRef as ReactComponent };